import React, { Component } from 'react'
import shortid from 'shortid'
import { withStyles } from '@material-ui/styles'
import { CoPartnerForm } from './../forms'
import { Dashboard } from './../layouts'
import axios from './../plugins/axios'

const styles = theme => ({
    //
})

class CoPartnerUpdate extends Component {
    constructor(props) {
        super(props)

        this.state = {
            title: 'Хамтрагч байгууллага',
            key: shortid.generate(),
            name: '',
            url: '',
            logo: ''
        }
    }

    componentWillMount = () => {
        this.fetchData()
    }

    fetchData = async () => {
        const { match } = this.props
        const { id } = match.params

        try {
            const { data } = await axios.get(`/partners/${id}`, { progress: true})

            this.setState({
                key: shortid.generate(),
                name: data.name,
                url: data.url,
                logo: data.logo
            })
        } catch (e) {
            //
        }
    }

    render() {
        const {
            title,
            key,
            name,
            url,
            logo
        } = this.state
        const { match } = this.props
        const { id } = match.params
        return (
            <Dashboard title={title}>
                <CoPartnerForm
                    key={key}
                    path={`partners/${id}`}
                    method="put"
                    name={name}
                    url={url}
                    logo={logo}
                    message="Амжилттай шинэчлэгдлээ"
                />
            </Dashboard>
        )
    }
}

export default withStyles(styles)(CoPartnerUpdate)
